export default __webpack_public_path__ + "static/media/personaje-Banner-03.6eb64712.png";